<template>
  <div class="assemble_list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="组合列表" name="first">
        <!-- 筛选 -->
        <Search :searchData="searchSource" @search="handleSearch"></Search>
        <!-- 表格 -->
        <WmsTable
        :isPagination="pagination" 
          :hasHeader="true"
          :isExpanded="true"
          :columns="listColumns"
          :dataSource="dataSource"
          @pageChange="pageChange"
        >
          <span slot="productImg" slot-scope="text, record">
            <img :src="text" alt="" />
          </span>
          <span slot="operation" slot-scope="text, record">
            <el-button>详情</el-button>
          </span>
          <!-- 展开后显示的表格 -->
          <span
            slot="expandedRender"
            slot-scope="record"
            name="expandedRender"
            :record="record"
          >
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                :label="item.label"
                prop="item.key"
                v-for="item in productColumns"
                :key="item.id"
              ></el-table-column>
            </el-table>
          </span>
        </WmsTable>
      </el-tab-pane>
      <el-tab-pane label="待拣货" name="second">配置管理</el-tab-pane>
      <el-tab-pane label="待移库" name="third">角色管理</el-tab-pane>
      <el-tab-pane label="任务列表" name="fourth">定时任务补偿</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ScanQuery from "@/components/ScanQuery";
import Search from "./components/search.vue";

import {
  listColumns,
  productColumns,
  searchSource,
} from "@/views/assemble/list";
export default {
  name: "assemble_list",
  components: {
    WmsTable,
    ScanQuery,
    Search,
  },
  props: {},
  data() {
    return {
      // 搜索项
      searchSource,
      activeName: "first",
      // 主表格
      listColumns,
      dataSource: [
        {
          id: 123,
          productName: "商品名称",
          productSku: "sku",
          specifications: "红",
          assembledNum: 12,
          productsNum: 123,
          status: "已组合",
          src: "",
        },
      ],
      //
      pagination: {
        current: 1,
        total: 0,
      },
      // 展开后的子表格
      productColumns,
      tableData: [],
    };
  },

  created() {
    this.$message.error("组合列表待开发");
  },

  methods: {
    handleClick(tab, event) {
    },
    // 分页器
    pageChange(pageData) {
    },
    // 筛选项
    handleSearch(params) {
      // const a = params.date[0].getTime();
      // console.log(a);
    },
  },
};
</script>

<style scoped lang="less">
.assemble_list {
  padding: 10px;
}
</style>
